import { Type } from '@angular/core';

import type { BaseQuoteForm } from 'app/home/create-quote/form-config/quote-form-base';
import { QuoteFormAboutYouComponent } from 'app/home/create-quote/forms/about-you/about-you.component';
import { QuoteFormCoApplicantComponent } from 'app/home/create-quote/forms/co-applicant/co-applicant.component';
import { QuoteFormCoApplicantInfoComponent } from 'app/home/create-quote/forms/co-applicant-info/co-applicant-info.component';
import { QuoteFormInsuranceExpirationComponent } from 'app/home/create-quote/forms/insurance-expiration/insurance-expiration.component';
import { QuoteFormInsuranceStatusComponent } from 'app/home/create-quote/forms/insurance-status/insurance-status.component';
import { QuoteFormPolicyStartDateComponent } from 'app/home/create-quote/forms/policy-start-date/policy-start-date.component';
import { QuoteFormPolicyTypeComponent } from 'app/home/create-quote/forms/policy-type/policy-type.component';
import { QuoteFormConstructionTypeComponent } from 'app/home/create-quote/forms/property-details/construction-type/construction-type.component';
import { QuoteFormExteriorWallComponent } from 'app/home/create-quote/forms/property-details/exterior-wall/exterior-wall.component';
import { QuoteFormFoundationTypeComponent } from 'app/home/create-quote/forms/property-details/foundation/foundation.component';
import { QuoteFormPropertyTypeComponent } from 'app/home/create-quote/forms/property-details/property-type/property-type.component';
import { QuoteFormRoofShapeComponent } from 'app/home/create-quote/forms/property-details/roof-shape/roof-shape.component';
import { QuoteFormRoofYearComponent } from 'app/home/create-quote/forms/property-details/roof-year/roof-year.component';
import { QuoteFormYearBuiltComponent } from 'app/home/create-quote/forms/property-details/year-built/year-built.component';
import { QuoteFormPropertyInformationComponent } from 'app/home/create-quote/forms/property-information/property-information.component';
import { QuoteFormRentalNumberComponent } from 'app/home/create-quote/forms/rental-number/rental-number.component';
import { QuoteFormRentalStatusComponent } from 'app/home/create-quote/forms/rental-status/rental-status.component';
import { QuoteFormResidencyComponent } from 'app/home/create-quote/forms/residency/residency.component';
import { QuoteFormUnitNumberCheckComponent } from 'app/home/create-quote/forms/unit-number-check/unit-number-check.component';
import { QuoteFormUnitNumberEntryComponent } from 'app/home/create-quote/forms/unit-number-entry/unit-number-entry.component';

/**
 *
 * COMPONENT MAPPINGS
 * Maps the path provided by the v1 API to a quote form
 * Paths are defined here: https://github.com/kin/dot-com/blob/master/app/models/acquisition/page/path.rb
 */
export type QuoteFormComponent = Type<BaseQuoteForm<unknown>>;

const quoteFormMappingArray: [string, QuoteFormComponent][] = [
  ['about-you', QuoteFormAboutYouComponent],
  ['policy-type', QuoteFormPolicyTypeComponent],
  ['unit-number-check', QuoteFormUnitNumberCheckComponent],
  ['unit-number-entry', QuoteFormUnitNumberEntryComponent],
  ['insurance-status', QuoteFormInsuranceStatusComponent],
  ['rental-status', QuoteFormRentalStatusComponent],
  ['rental-number', QuoteFormRentalNumberComponent],
  ['residency', QuoteFormResidencyComponent],
  ['policy-start-date', QuoteFormPolicyStartDateComponent],
  ['co-applicant', QuoteFormCoApplicantComponent],
  ['co-applicant-info', QuoteFormCoApplicantInfoComponent],
  ['property-type', QuoteFormPropertyTypeComponent],
  ['roof-shape', QuoteFormRoofShapeComponent],
  ['insurance-expiration', QuoteFormInsuranceExpirationComponent],
  ['year-built', QuoteFormYearBuiltComponent],
  ['construction-type', QuoteFormConstructionTypeComponent],
  ['roof-year', QuoteFormRoofYearComponent],
  ['exterior-wall', QuoteFormExteriorWallComponent],
  ['property-information', QuoteFormPropertyInformationComponent],
  ['foundation', QuoteFormFoundationTypeComponent],
] as const;

export type QuoteFormMappingKey = (typeof quoteFormMappingArray)[number][0];

export const quoteFormMappingMap = new Map<QuoteFormMappingKey, QuoteFormComponent>(quoteFormMappingArray);
